






















import Toast from '@/components/display/toast.vue';

import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { FeedProduct } from '../../../../models';
import { FeedProductService } from '../../../../services';

import InformationRow from '@/components/display/information-row.vue';

@Component({
	components: {
		InformationRow,
	},
})
export default class FeedProductName extends Vue {
	@Prop({ required: true, type: Object })
	private feedProduct!: FeedProduct;

	@Inject('feedProductService')
	private service!: FeedProductService;

	public editing: boolean = false;
	public newName: string = '';

	private toast: Toast = new Toast();

	public created(): void {
		this.newName = this.feedProduct.name ?? '';
	}

	public toggleEditing(): void {
		this.editing = !this.editing;
		if (this.editing === false) {
			this.newName = this.feedProduct.name ?? '';
		}
	}

	public async updateName(): Promise<void> {
		if (this.newName.length === 0) {
			this.toast.makeToast('Product name must not be empty', 'Invalid product name', 'warning');
			return;
		}
		this.feedProduct.name = this.newName;
		const updateResult = await this.service.updateProduct(this.feedProduct);
		if (updateResult?.errorMessage) {
			this.toast.makeToast(updateResult.errorMessage, 'Failed to update name', 'danger');
			return;
		}
		this.toast.makeToast(`Name changed to ${this.newName}`, 'Updated name', 'success');
		this.editing = false;
	}
}
